<div class="birth-date-input">
  <div class="birth-date-field-wrap">
    <input
      class="form-control birth-date-field"
      type="text"
      inputmode="numeric"
      [value]="text()"
      (input)="onInput($any($event.target).value)"
      [placeholder]="translatedText().datePlaceholder"
      maxlength="10"
      [attr.aria-label]="translatedText().dateAria"
    />
    <button
      eBtn
      size="xs"
      compact
      squared
      type="button"
      class="birth-date-calendar-btn"
      [class.is-active]="showCalendar()"
      [tooltip]="translatedText().openCalendarTooltip"
      [attr.aria-pressed]="showCalendar()"
      [attr.aria-label]="translatedText().openCalendar"
      (click)="toggleCalendar()"
    >
      <i eIcon icon="calendar-days"></i>
    </button>

    @if (showCalendar()) {
      <div class="birth-date-calendar-pop">
        <e-date-picker
          [locale]="calendarLocale()"
          [minYear]="1900"
          [value]="calendarValue()"
          (valueChange)="onCalendarChange($any($event))"
        ></e-date-picker>
      </div>
    }
  </div>
</div>
